export const REPORTS_RANGE_TYPE = "REPORTS_RANGE_TYPE";
export const REPORTS_FIRST_PERIOD = "REPORTS_FIRST_PERIOD";
export const REPORTS_SECOND_PERIOD = "REPORTS_SECOND_PERIOD";
export const REPORTS_FIRST_DATA = "REPORTS_FIRST_DATA";
export const REPORTS_SECOND_DATA = "REPORTS_SECOND_DATA";
export const REPORTS_LOADING = "REPORTS_LOADING";
